import { useEffect, useState, useRef, useCallback } from 'react';

export const ANIMATION_STATE = {
    INITIAL: 'INITIAL',
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
};

export const ANIMATION_DURATION = 1000;

export function useAnimationState({ startAfter }) {
    const [animationState, setAnimationState] = useState(ANIMATION_STATE.INITIAL);
    const animationTimeoutRef = useRef();
    const expirationTimeoutRef = useRef();

    const start = useCallback(() => {
        setAnimationState(ANIMATION_STATE.STARTED);
        expirationTimeoutRef.current = setTimeout(async () => {
            setAnimationState(ANIMATION_STATE.COMPLETED);
        }, ANIMATION_DURATION);
    }, []);

    const init = useCallback(() => {
        animationTimeoutRef.current = setTimeout(async () => {
            start();
        }, startAfter);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const teardown = useCallback(() => {
        if (animationTimeoutRef.current) {
            clearTimeout(animationTimeoutRef.current);
        }
        if (expirationTimeoutRef.current) {
            clearTimeout(expirationTimeoutRef.current);
        }
    }, []);

    const startAnimating = useCallback(() => {
        teardown();
        start();
    }, [teardown, start]);

    useEffect(() => {
        init();
        return teardown;
    }, [init, teardown]);

    return {
        animationState,
        startAnimating,
    };
}
